<template>
  <div class="lift-step-two">
    <v-layout
      justify-space-between
      mt-8
    >
      <v-flex
        column
        xs4
      >
        <div class="content img1">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_2a.svg">
            <v-text-field
              v-model="form.c"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema C"
              :class="{ error: errors.has('Schema C') }"
              type="number"
              style="top: 31.1%;left: 2%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.b"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema B"
              :class="{ error: errors.has('Schema B') }"
              type="number"
              style="top: 50.9%;left: 1.9%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.a"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema A"
              :class="{ error: errors.has('Schema A') }"
              type="number"
              style="top: 83.1%;left: 0.2%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.d"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema D"
              :class="{ error: errors.has('Schema D') }"
              type="number"
              style="top: 17.8%;left: 75.4%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.e"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema E"
              :class="{ error: errors.has('Schema E') }"
              type="number"
              style="top: 31%;left: 75.5%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.g"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema G"
              :class="{ error: errors.has('Schema G') }"
              type="number"
              style="top: 59.6%;left: 75.4%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.f"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema F"
              :class="{ error: errors.has('Schema F') }"
              type="number"
              style="top: 92.6%;left: 50.4%;"
              height="100%"
              outlined
            />
          </div>
        </div>
      </v-flex>
      <v-flex
        column
        xs8
      >
        <div class="content img2">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_2b.svg">
            <v-text-field
              v-model="form.h"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema H"
              :class="{ error: errors.has('Schema H') }"
              type="number"
              style="top: 7.2%;left: 33.2%;"
              height="100%"
              class="large"
              outlined
            />
            <v-text-field
              v-model="form.i"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema I"
              :class="{ error: errors.has('Schema I') }"
              type="number"
              style="top: 21.3%;left: 33.2%;"
              height="100%"
              class="large"
              outlined
            />
            <v-text-field
              v-model="form.j"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema J"
              :class="{ error: errors.has('Schema J') }"
              type="number"
              style="top: 31.4%;left: 33.2%;"
              height="100%"
              class="large"
              outlined
            />
            <v-text-field
              v-model="form.k"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema K"
              :class="{ error: errors.has('Schema K') }"
              type="number"
              style="top: 64.3%;left: 34.8%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.l"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema L"
              :class="{ error: errors.has('Schema L') }"
              type="number"
              style="top: 26.9%;left: 86%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.m"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema M"
              :class="{ error: errors.has('Schema M') }"
              type="number"
              style="top: 22.9%;left: 75.3%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.n"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema N"
              :class="{ error: errors.has('Schema N') }"
              type="number"
              style="top: 39.5%;left: 71.6%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.o1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema O1"
              :class="{ error: errors.has('Schema O1') }"
              type="number"
              style="top: 54%;left: 0;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.o2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema O2"
              :class="{ error: errors.has('Schema O2') }"
              type="number"
              style="top: 54%;left: 69.1%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.p1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema P1"
              :class="{ error: errors.has('Schema P1') }"
              type="number"
              style="top: 44.8%;left: 10.1%;"
              height="100%"
              class="medium"
              outlined
            />
            <v-text-field
              v-model="form.p2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema P2"
              :class="{ error: errors.has('Schema P2') }"
              type="number"
              style="top: 44.8%;left: 57.2%;"
              height="100%"
              class="medium"
              outlined
            />
            <v-text-field
              v-model="form.q1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema Q1"
              :class="{ error: errors.has('Schema Q1') }"
              type="number"
              style="top: 70.2%;left: 9%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.q2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema Q2"
              :class="{ error: errors.has('Schema Q2') }"
              type="number"
              style="top: 70.2%;left: 60.3%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.r1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema R1"
              :class="{ error: errors.has('Schema R1') }"
              type="number"
              style="top: 41.9%;left: 25.5%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.r2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema R2"
              :class="{ error: errors.has('Schema R2') }"
              type="number"
              style="top: 42.2%;left:43.5%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.s1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema S1"
              :class="{ error: errors.has('Schema S1') }"
              type="number"
              style="top: 52.5%;left: 23.6%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.s2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema S2"
              :class="{ error: errors.has('Schema S2') }"
              type="number"
              style="top: 52.5%;left: 45.3%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.t1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema T1"
              :class="{ error: errors.has('Schema T1') }"
              type="number"
              style="top: 62.3%;left: 22%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.t2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema T2"
              :class="{ error: errors.has('Schema T2') }"
              type="number"
              style="top: 62.8%;left: 47.5%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.u1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema U1"
              :class="{ error: errors.has('Schema U1') }"
              type="number"
              style="top: 72.2%;left: 19.2%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.u2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema U2"
              :class="{ error: errors.has('Schema U2') }"
              type="number"
              style="top: 72.9%;left: 49.8%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.v1"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema V1"
              :class="{ error: errors.has('Schema V1') }"
              type="number"
              style="top: 92.9%;left: 14.9%;"
              height="100%"
              outlined
            />
            <v-text-field
              v-model="form.v2"
              v-validate="'numeric|max:4'"
              data-vv-name="Schema V2"
              :class="{ error: errors.has('Schema V2') }"
              type="number"
              style="top: 92.9%;left: 54.5%;"
              height="100%"
              outlined
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <h3 class="mb-2 mt-4">Réf LPPR</h3>
    
    <v-layout
      justify-space-between
      mt-8
      wrap
    >
      <v-flex
        v-for="article in articlesList"
        :key="article.article_id"
        sm6
      >
        <v-layout class="checkbox-input-container">
          <v-flex>
            <v-checkbox
              v-model="getArticleFormData(article.article_id).idc_want"
              :label="article.label"
              hide-details
              @change="onArticleCheckChange(article.article_id, $event)"
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex
            v-if="article.idc_entry"
            class="checkbox-input visible"
          >
            <InputNumber
              v-model="getArticleFormData(article.article_id).value"
              class="input-number"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-textarea
      v-model="form.comment"
      filled
      name="Ajouter un commentaires :"
      label="Ajouter un commentaires :"
    />

  </div>
</template>

<script>
import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "LiftStepTwo",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    cols: 3
  }),
  computed: {
    columns() {
      let columns = [];
      this.articlesList.forEach((article, index) => {
        article.index = index;
      });
      let mid = Math.ceil(this.articlesList.length / this.cols);
      for (let col = 0; col < this.cols; col++) {
        columns.push(this.articlesList.slice(col * mid, col * mid + mid));
      }
      return columns;
    }
  },
  methods: {
    /**
     * Récupère les données d'un article dans form.articles à partir de son ID
     * @param {String|Number} articleId - L'ID de l'article à récupérer
     * @returns {Object} - L'objet article correspondant dans form.articles
     */
    getArticleFormData(articleId) {
      // Chercher l'article dans form.articles
      const article = this.form.articles.find(a => a.article_id === articleId);
      
      // Si l'article n'existe pas, créer un nouvel objet avec des valeurs par défaut
      if (!article) {
        const newArticle = {
          article_id: articleId,
          idc_want: false,
          value: null
        };
        
        // Ajouter le nouvel article à form.articles
        this.form.articles.push(newArticle);
        
        return newArticle;
      }
      
      return article;
    },
    
    /**
     * Réinitialise la valeur d'un article à null lorsqu'il est décoché
     * @param {String|Number} articleId - L'ID de l'article
     * @param {Boolean} checked - État de la case à cocher
     */
    onArticleCheckChange(articleId, checked) {
      const article = this.getArticleFormData(articleId);
      if (!checked && article.value !== null) {
        article.value = null;
      }
    }
  },
  async created() {
    this.$validator = this.parentValidator;

    await this.loadArticles("LIFT");

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  }
};
</script>

<style lang="scss">
.lift-step-two {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 23.9%;
        height: 6%;
        @media (max-width: 800px) {
          height: 4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 23.9%;
          height: 6%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 7.8%;
          height: 5.7%;
          &.large {
            width: 10.3%;
            height: 6.6%;
          }
          &.medium {
            width: 9.2%;
            height: 5.5%;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
